const initialState = {
  listCabang: [],
  closeTabTargetCabang: false,
  listAllAnggotaCabang: [],
  statusInputTargetCabang: true,
  statusInputTargetCabangProduktif: true,
  listTargetCabang: [],
  listCabangKoor: [],
  listTargetCabangProduktif: [],
};

const cabangReducer = (state = initialState, action) => {
  let { type, data } = action;
  switch (type) {
    case "SET_CLOSE_TAB_TARGET_CABANG":
      return {
        ...state,
        closeTabTargetCabang: data,
      };
    case "SET_ALLCABANG":
      return {
        ...state,
        listCabang: data,
      };
    case "SET_ALLCABANG_KOOR":
      return {
        ...state,
        listCabangKoor: data,
      };
    case "SET_ALLANGGOTACABANG":
      return {
        ...state,
        listAllAnggotaCabang: data,
      };
    case "SET_STATUS_INPUT_TARGET_CABANG":
      return {
        ...state,
        statusInputTargetCabang: data,
      };
    case "SET_ALL_TARGET_CABANG":
      return {
        ...state,
        listTargetCabang: data,
      };
    case "SET_ALL_TARGET_CABANG_PRODUKTIF":
      return {
        ...state,
        listTargetCabangProduktif: data,
      };

    case "SET_STATUS_INPUT_TARGET_CABANG_PRODUKTIF":
      return {
        ...state,
        statusInputTargetCabangProduktif: data,
      };

    default:
      return state;
  }
};
export default cabangReducer;
